import {Injectable} from '@angular/core';
import {environment} from '../../../environments/environment';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import { SharedModule } from '../shared.module';
import { ApiRequestService } from 'src/app/services/api-request/api-request.service';

@Injectable({
  providedIn: SharedModule
})
export class FunnelReportService {
    // private FUNNEL_REPORT= environment.apiUrl + '/v2/api/survey/funnel-report/';
    private FUNNEL_REPORT= '/v2/api/survey/funnel-report';

    private httpPostOptions = {
        headers: new HttpHeaders().set('Content-Type', 'application/json'),
        withCredentials: true
      };
    
  constructor(private http: HttpClient, private apiRequest: ApiRequestService) {}

  getFunnelReport(data:any){
    let opt = {};
    opt['httpOptions'] = this.httpPostOptions;
    let pathUrl = this.FUNNEL_REPORT +'/'+ data['studyId']
    return this.apiRequest.request('POST',pathUrl,data,opt);
    // return this.http.post<any>(this.FUNNEL_REPORT + data['studyId'], data, this.httpPostOptions);
  }

  getFunnelReportFilterDate(data:any){
    let pathUrl = this.FUNNEL_REPORT +'/filter-date/'+ data['studyId']
    return this.apiRequest.request('GET',pathUrl);
  }

  exportFunnelReport(data:any){

  }

}